import { createFileRoute } from "@tanstack/react-router";
import AdminMoneyball from "@/pages/AdminMoneyball";

export const Route = createFileRoute("/admin/moneyball/")({
  component: AdminMoneyball,
});
